import { Locale } from '@/i18n/models/Locale';

function getNumber(value: string | number): number {
  return Number(String(value).replace('%', ''));
}

export function formatPercentage(value: string | number, locale: Locale): string | number {
  const num = getNumber(value);
  if (Number.isNaN(num)) return String(value);

  const newValue = `${num.toFixed(2)}%`;
  return locale === Locale.NL ? newValue.replace('.', ',') : newValue;
}
